<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RIlXKq/tc-custom/9781909808706.jpg?1718183453114" alt="This image is the cover for the book Marguerite Patten's 100 Top Teatime Treats"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marguerite Patten's 100 Top Teatime Treats
      </h1>
      <p class="bookDescription body article font2">
        <b>England’s premier food maven shares recipes for cakes and dainties designed to make teatime sparkle.</b><br/>  <br/> Only the most hardened dieter can resist the pleasures of afternoon tea. Its enjoyment, whether it is a simple slice of home-baked cake or dainty sandwiches followed by scones oozing with jam and cream, is part of our culture and is a tradition acted out each and every day in tea-rooms up and down the country.<br/>  <br/> This then is the perfect book for all tea-time lovers, with over 100 recipes chosen by the un-crowned queen of British cookery, Marguerite Patten, and is published as a tribute to and celebration of Marguerite’s 90th year. There are recipes for cakes, breads, biscuits, sandwiches, and savories from England, Scotland, Wales, and Ireland as well as recipes from teatimes around the world. But teatime isn’t teatime without a pot of tea, so the book also traces the history of Britain’s national beverage with a guide to all the different blends and styles available.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marguerite Patten
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grub Street Cookery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f70aecc8